import React from 'react';

/**
 * CommandCenterEmptyState — three states in one:
 *   variant='no-results'  → search returned nothing
 *   variant='empty'       → the tools list itself is empty (shouldn't happen but is safe)
 *   variant='error'       → tools failed to load
 */
export default function CommandCenterEmptyState({
  variant = 'no-results',
  onClear,
  onRetry,
}) {
  if (variant === 'error') {
    return (
      <div className="cc-empty" data-testid="cc-empty-error" role="alert">
        <h3>We couldn&rsquo;t load your tools.</h3>
        <p>Check your connection and try again — nothing has been lost.</p>
        <button type="button" onClick={onRetry} data-testid="cc-empty-retry">Retry</button>
      </div>
    );
  }
  if (variant === 'empty') {
    return (
      <div className="cc-empty" data-testid="cc-empty-none">
        <h3>No tools available yet.</h3>
        <p>Contact your admin — the tool catalog appears to be empty.</p>
      </div>
    );
  }
  return (
    <div className="cc-empty" data-testid="cc-empty-no-results">
      <h3>No tools match your search.</h3>
      <p>Try a broader term — grievance, safety, discipline, evidence, or overtime.</p>
      <button type="button" onClick={onClear} data-testid="cc-empty-clear">Clear Search</button>
    </div>
  );
}
